<template>
  <div>
    <div>
      <div class="body p-4">
        <span class="text-primary h2 d-flex align-items-center">
          <button
            @click="$router.push(`/empresas`)"
            class="btn font-weight-bold btn-primary text-white btn-shadow me-3"
          >
            <i class="fa fa-arrow-left"></i>
          </button>
          <b>Notas fiscais</b>
        </span>
        <!-- Notas Fiscais -->

        <div class="card p-4 text-start">
          <h4>Buscar</h4>
          <div class="row">
            <div class="col-lg-2 col-sm-5">
              <select-input
                :options="months"
                title="mês"
                :pre-selected-id="new Date().getMonth()"
                v-on:update-selected="(e) => updateMonth(e)"
              />
            </div>
            <div class="col-lg-2 col-sm-5">
              <select-input
                title="ano"
                :year="true"
                v-on:update-selected="(e) => updateYear(e)"
              />
            </div>
          </div>
        </div>
        <div class="card p-3 mt-4 text-start" v-if="!invoices.length">
          Não encontramos Notas Fiscais cadastradas para esse mês ({{
            months[month]
          }})
        </div>
        <div class="card text-start p-2" v-else>
          <div class="collection text-start m-0">
            <div
              class="collection-item relative item-title"
              v-for="(item, d_index) in invoices"
              :key="d_index"
            >
              <p class="collection-title d-flex align-items-center">
                <span class="me-auto">
                  <span
                    class="badge rounded-pill bg-success px-3 me-2"
                    v-if="item.type === 1"
                  >
                    <i class="fa-solid fa-right-to-bracket pe-1"></i>
                    Entrada </span
                  ><span
                    class="badge rounded-pill bg-danger px-3 me-2"
                    v-else-if="item.type === 2"
                  >
                    <i class="fa-solid fa-right-from-bracket pe-1"></i> Saída
                  </span>
                  <span class="badge rounded-pill bg-info px-3 me-2" v-else>
                    <i class="fa-solid fa-reply pe-1"></i> Devolução
                  </span>
                  <span class="">
                    <b>{{ `#${d_index + 1} ${item.name}` || "-" }}</b> (<a
                      :href="item.document"
                      >{{ item.document }}</a
                    >)
                  </span>
                </span>
                <span
                  class="mx-2"
                  v-tooltip="'Ver arquivo'"
                  @click="handleViewFile(item.id, 'invoices')"
                >
                  <button class="btn btn-light shadow-sm">
                    <i class="fas fa-eye text-info"></i>
                  </button>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import SelectInput from "@/components/SelectInput.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "invoices-modal",
  props: {
    modal: Object,
  },
  components: {
    SelectInput,
  },
  data() {
    return {
      month: 1,
      year: 2024,
      invoices: [],
      classes: ["NFe", "NFCe", "NFSe", "outro"],
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  async mounted() {
    this.month = new Date().getMonth();
    this.year = new Date().getFullYear();
    await this.loadInvoices();
  },
  methods: {
    async handleViewFile(id, functionality) {
      try {
        const { data } = await api.get(
          `/user-accountant/document/${this.$route.params.id}?functionality=${functionality}&functionality_row_id=${id}`
        );
        window.open(`${data.public_url}`, "_blank");
      } catch (e) {
        let message =
          "Ocorreu um erro ao carregar o documento. Recarregue a página e tente novamente.";
        if (e.response.data.message) message = e.response.data.message;
        toast.error(message);
      }
    },
    async loadInvoices() {
      try {
        const { data } = await api.get(
          `/user-accountant/invoices/${this.$route.params.id}${this.getUrl()}`
        );
        this.invoices = data;
      } catch (e) {
        let message =
          "Ocorreu um erro ao carregar as informações das notas fiscais. Recarregue a página e tente novamente.";
        if (e.response.data.message) message = e.response.data.message;
        toast.error(message);
      }
    },
    updateMonth(e) {
      this.month = e;
    },
    updateYear(e) {
      this.year = e;
    },
    getUrl() {
      let url = `?company_id=${this.$route.params.id}`;
      const month = this.month + 1;
      if (month) url += `&month=${month}`;
      if (this.year) url += `&year=${this.year}`;
      return url;
    },
  },
  watch: {
    month: async function () {
      await this.loadInvoices();
    },
    year: async function () {
      await this.loadInvoices();
    },
  },
};
</script>
<style scoped>
.close-button {
  border: none;
  background-color: transparent;
}
.collection {
  border: none;
}
.relative {
  position: relative;
}
.badge {
  border-radius: 2px;
  font-weight: 300;
}
.collection-title {
  margin: 0;
}
</style>
